module.exports = __webpack_public_path__ + "img/ic_upload.e2d90834.svg";